<template>
  <div data-app>
    <FeedComments
      v-model="commentsBottomSheet"
      :post="commentingPost"
      @newComment="onNewComment"
      @deleteComment="onDeleteComment"
      @clearComments="commentingPost = { comments: [] }"
      :automaticallyDonation="automaticallyDonation"
      @resetAutomaticallyDonation="automaticallyDonation = false"
    ></FeedComments>

    <v-dialog
      v-model="showPayPerViewPopup"
      max-width="768px"
      style="overflow: hidden; color: blue"
    >
      <v-card style="overflow: hidden">
        <PayPerViewPopup
          @refresh="$emit('refresh')"
          :post="postPayPerView"
          :user="postPayPerView.owner"
          :balance="balance"
          @close="showPayPerViewPopup = false"
        ></PayPerViewPopup>
      </v-card>
    </v-dialog>

    <div v-if="showWelcomeCards" class="welcome-card-wrapper">
      <div class="welcome-card" v-if="user.name == user.slug">
        <div class="welcome-card__close">
          <v-btn icon @click="closeWelcomeCard()">
            <i class="fa-light fa-times"></i>
          </v-btn>
        </div>
        <div class="welcome-card__image">
          <v-img
            src="https://sidermoney.nyc3.digitaloceanspaces.com/logos/undraw_happy_news_re_tsbd.svg"
            width="150px"
          >
          </v-img>
        </div>
        <div class="welcome-card__title">
          <h2>Introduce yourself</h2>
        </div>
        <div class="welcome-card__description">
          <p>
            Tell us a little about yourself so we can help you get the most out
            of your experience.
          </p>
        </div>
        <v-btn
          class="welcome-card__buttons btn-sider-money"
          elevation="0"
          @click="$router.push('/settings/personal-data')"
        >
          Add details
        </v-btn>
      </div>
    </div>
    <div v-if="showWelcomePostCard" class="welcome-card-wrapper">
      <div class="welcome-card">
        <div class="welcome-card__close">
          <v-btn icon @click="closeWelcomeCard()">
            <i class="fa-light fa-times"></i>
          </v-btn>
        </div>
        <div class="welcome-card__image">
          <v-img src="/assets/images/make_a_post.svg" width="150px"></v-img>
        </div>
        <div class="welcome-card__title">
          <h2>You are now a creator!</h2>
        </div>
        <div class="welcome-card__description">
          <p>Start sharing your content.</p>
        </div>
        <v-btn
          class="welcome-card__buttons btn-sider-money"
          elevation="0"
          @click="openPostPopup"
        >
          New post
        </v-btn>
      </div>
    </div>
    <div v-if="showWelcomeCards" class="welcome-card-wrapper">
      <div class="welcome-card">
        <div class="welcome-card__close">
          <v-btn icon @click="closeWelcomeCard()">
            <i class="fa-light fa-times"></i>
          </v-btn>
        </div>
        <div class="welcome-card__image">
          <v-img
            src="https://sidermoney.nyc3.digitaloceanspaces.com/logos/undraw_happy_news_re_tsbd.svg"
            width="150px"
          >
          </v-img>
        </div>
        <div class="welcome-card__title">
          <h2>Become a creator</h2>
        </div>
        <div class="welcome-card__description">
          <p>Create your own content and earn money with your audience.</p>
        </div>
        <v-btn
          class="welcome-card__buttons btn-sider-money"
          elevation="0"
          @click="$router.push('/become-a-creator')"
        >
          Set up
        </v-btn>
      </div>
    </div>
    <div
      v-for="(post, postIndex) in posts"
      :key="postIndex + showPremiumCard.length"
      :class="`feed-post-home`"
    >
      <div class="premium-container">
        <!-- {{ showPremiumCard[postIndex] }} -->

        <!-- v-if="showPremiumCard[postIndex]" -->
        <div class="premium-card" ref="showPremiumCard">
          <div class="premium-header">
            <div class="premium-text">
              <v-list
                style="background-color: transparent !important; padding: 0"
                :id="`post-${post.id}-feed`"
              >
                <v-list-item
                  style="
                    background-color: transparent !important;
                    padding: 0.5em;
                    padding-top: 0em;
                  "
                >
                  <router-link
                    :to="`/${post.owner.slug}`"
                    style="text-decoration: none"
                  >
                    <v-avatar size="42px" class="feed-avatar">
                      <img :src="post.owner.avatar ? `${post.owner.avatar}` : defaultImages.avatar" />
                    </v-avatar>
                  </router-link>
                  <v-list-item-content style="padding: 0">
                    <v-list-item-title
                      class="headline mb-1 text-white"
                      style="margin-left: 0.5em"
                    >
                      <router-link
                        :to="`/${post.owner.slug}`"
                        style="text-decoration: none; color: unset"
                      >
                        <span
                          style="
                            font-size: 14px;
                            text-transform: none;
                            font-weight: 600;
                          "
                          class="text-gray-strong"
                          >{{ post.owner.name }}
                          <svg
                            v-if="post.owner.verified_badge"
                            fill="#007BFF"
                            style="margin-bottom: -2px"
                            width="17"
                            viewBox="0 0 24 24"
                            aria-label="Conta verificada"
                            role="img"
                            class="r-1cvl2hr r-4qtqp9 r-yyyyoo r-1xvli5t r-f9ja8p r-og9te1 r-bnwqim r-1plcrui r-lrvibr"
                          >
                            <g>
                              <path
                                d="M22.5 12.5c0-1.58-.875-2.95-2.148-3.6.154-.435.238-.905.238-1.4 0-2.21-1.71-3.998-3.818-3.998-.47 0-.92.084-1.336.25C14.818 2.415 13.51 1.5 12 1.5s-2.816.917-3.437 2.25c-.415-.165-.866-.25-1.336-.25-2.11 0-3.818 1.79-3.818 4 0 .494.083.964.237 1.4-1.272.65-2.147 2.018-2.147 3.6 0 1.495.782 2.798 1.942 3.486-.02.17-.032.34-.032.514 0 2.21 1.708 4 3.818 4 .47 0 .92-.086 1.335-.25.62 1.334 1.926 2.25 3.437 2.25 1.512 0 2.818-.916 3.437-2.25.415.163.865.248 1.336.248 2.11 0 3.818-1.79 3.818-4 0-.174-.012-.344-.033-.513 1.158-.687 1.943-1.99 1.943-3.484zm-6.616-3.334l-4.334 6.5c-.145.217-.382.334-.625.334-.143 0-.288-.04-.416-.126l-.115-.094-2.415-2.415c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l1.77 1.767 3.825-5.74c.23-.345.696-.436 1.04-.207.346.23.44.696.21 1.04z"
                              ></path>
                            </g>
                          </svg>

                          <svg
                            v-if="post.owner.ambassador"
                            width="15"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style="
                              margin-left: 4px;
                              transform: translate(0, 1px);
                            "
                          >
                            <path
                              d="M21.001 11C21.001 9.42 20.126 8.05 18.853 7.4C19.007 6.965 19.091 6.495 19.091 6C19.091 3.79 17.381 2.002 15.273 2.002C14.803 2.002 14.353 2.086 13.937 2.252C13.319 0.915 12.011 0 10.501 0C8.991 0 7.685 0.917 7.064 2.25C6.649 2.085 6.198 2 5.728 2C3.618 2 1.91 3.79 1.91 6C1.91 6.494 1.993 6.964 2.147 7.4C0.875 8.05 0 9.418 0 11C0 12.495 0.782 13.798 1.942 14.486C1.922 14.656 1.91 14.826 1.91 15C1.91 17.21 3.618 19 5.728 19C6.198 19 6.648 18.914 7.063 18.75C7.683 20.084 8.989 21 10.5 21C12.012 21 13.318 20.084 13.937 18.75C14.352 18.913 14.802 18.998 15.273 18.998C17.383 18.998 19.091 17.208 19.091 14.998C19.091 14.824 19.079 14.654 19.058 14.485C20.216 13.798 21.001 12.495 21.001 11.001V11ZM14.385 7.666L10.051 14.166C9.906 14.383 9.669 14.5 9.426 14.5C9.283 14.5 9.138 14.46 9.01 14.374L8.895 14.28L6.48 11.865C6.187 11.572 6.187 11.097 6.48 10.805C6.773 10.513 7.248 10.511 7.54 10.805L9.31 12.572L13.135 6.832C13.365 6.487 13.831 6.396 14.175 6.625C14.521 6.855 14.615 7.321 14.385 7.665V7.666Z"
                              fill="#007BFF"
                            />
                            <path
                              d="M20 10.8571C20 9.72857 19.3334 8.75 18.3635 8.28571C18.4808 7.975 18.5448 7.63929 18.5448 7.28571C18.5448 5.70714 17.242 4.43 15.636 4.43C15.2779 4.43 14.9351 4.49 14.6182 4.60857C14.1473 3.65357 13.1508 3 12.0004 3C10.85 3 9.85496 3.655 9.38184 4.60714C9.06566 4.48929 8.72206 4.42857 8.36398 4.42857C6.75644 4.42857 5.45517 5.70714 5.45517 7.28571C5.45517 7.63857 5.5184 7.97429 5.63573 8.28571C4.66663 8.75 4 9.72714 4 10.8571C4 11.925 4.59578 12.8557 5.47955 13.3471C5.46431 13.4686 5.45517 13.59 5.45517 13.7143C5.45517 15.2929 6.75644 16.5714 8.36398 16.5714C8.72206 16.5714 9.0649 16.51 9.38108 16.3929C9.85344 17.3457 10.8484 18 11.9996 18C13.1516 18 14.1466 17.3457 14.6182 16.3929C14.9343 16.5093 15.2772 16.57 15.636 16.57C17.2436 16.57 18.5448 15.2914 18.5448 13.7129C18.5448 13.5886 18.5357 13.4671 18.5197 13.3464C19.4019 12.8557 20 11.925 20 10.8579V10.8571ZM14.9595 8.47571L11.6575 13.1186C11.5471 13.2736 11.3665 13.3571 11.1814 13.3571C11.0724 13.3571 10.962 13.3286 10.8644 13.2671L10.7768 13.2L8.93691 11.475C8.71368 11.2657 8.71368 10.9264 8.93691 10.7179C9.16014 10.5093 9.52202 10.5079 9.74449 10.7179L11.093 11.98L14.0071 7.88C14.1824 7.63357 14.5374 7.56857 14.7995 7.73214C15.0631 7.89643 15.1347 8.22929 14.9595 8.475V8.47571Z"
                              fill="#007BFF"
                            />
                            <path
                              d="M17 9.85714C17 8.72857 16.3334 7.75 15.3635 7.28571C15.4808 6.975 15.5448 6.63929 15.5448 6.28571C15.5448 4.70714 14.242 3.43 12.636 3.43C12.2779 3.43 11.9351 3.49 11.6182 3.60857C11.1473 2.65357 10.1508 2 9.00038 2C7.84996 2 6.85496 2.655 6.38184 3.60714C6.06566 3.48929 5.72206 3.42857 5.36398 3.42857C3.75644 3.42857 2.45517 4.70714 2.45517 6.28571C2.45517 6.63857 2.5184 6.97429 2.63573 7.28571C1.66663 7.75 1 8.72714 1 9.85714C1 10.925 1.59578 11.8557 2.47955 12.3471C2.46431 12.4686 2.45517 12.59 2.45517 12.7143C2.45517 14.2929 3.75644 15.5714 5.36398 15.5714C5.72206 15.5714 6.0649 15.51 6.38108 15.3929C6.85344 16.3457 7.84844 17 8.99962 17C10.1516 17 11.1466 16.3457 11.6182 15.3929C11.9343 15.5093 12.2772 15.57 12.636 15.57C14.2436 15.57 15.5448 14.2914 15.5448 12.7129C15.5448 12.5886 15.5357 12.4671 15.5197 12.3464C16.4019 11.8557 17 10.925 17 9.85786V9.85714ZM11.9595 7.47571L8.65754 12.1186C8.54707 12.2736 8.36651 12.3571 8.18137 12.3571C8.07243 12.3571 7.96195 12.3286 7.86444 12.2671L7.77682 12.2L5.93691 10.475C5.71368 10.2657 5.71368 9.92643 5.93691 9.71786C6.16014 9.50929 6.52202 9.50786 6.74449 9.71786L8.093 10.98L11.0071 6.88C11.1824 6.63357 11.5374 6.56857 11.7995 6.73214C12.0631 6.89643 12.1347 7.22929 11.9595 7.475V7.47571Z"
                              fill="#007BFF"
                            />
                            <path
                              d="M10.939 5.029V5.77C11.5803 5.796 12.135 5.887 12.603 6.043C13.071 6.19033 13.305 6.41567 13.305 6.719C13.305 6.98767 13.214 7.343 13.032 7.785C12.8587 8.227 12.7373 8.461 12.668 8.487C11.94 8.18367 11.3637 8.01467 10.939 7.98V9.449C12.759 9.51833 13.669 10.3937 13.669 12.075C13.669 12.8637 13.4437 13.5397 12.993 14.103C12.5423 14.6663 11.8577 14.9957 10.939 15.091V15.988C10.939 16.144 10.8913 16.248 10.796 16.3C10.7093 16.352 10.6357 16.378 10.575 16.378L10.393 16.326C10.2717 16.2567 10.211 16.144 10.211 15.988V15.13C9.483 15.1127 8.83733 14.9827 8.274 14.74C7.71933 14.4973 7.442 14.1897 7.442 13.817C7.442 13.3317 7.58933 12.842 7.884 12.348C7.91 12.296 7.94467 12.2397 7.988 12.179C8.69 12.6037 9.431 12.842 10.211 12.894V11.464C8.365 11.3513 7.442 10.4067 7.442 8.63C7.442 7.85 7.689 7.20867 8.183 6.706C8.677 6.20333 9.353 5.9 10.211 5.796V5.029C10.211 4.873 10.2543 4.769 10.341 4.717C10.4363 4.665 10.5143 4.639 10.575 4.639L10.757 4.691C10.8783 4.76033 10.939 4.873 10.939 5.029ZM11.862 12.01C11.862 11.8107 11.7927 11.6763 11.654 11.607C11.524 11.529 11.2857 11.4813 10.939 11.464V12.868C11.5543 12.764 11.862 12.478 11.862 12.01ZM9.418 8.773C9.418 9.137 9.68233 9.34933 10.211 9.41V7.993C9.68233 8.07967 9.418 8.33967 9.418 8.773Z"
                              fill="white"
                            />
                          </svg>

                          <p
                            style="
                              font-size: 15px;
                              margin-left: 4px;
                              transform: translateY(-1.5px);
                              display: inline-block;
                            "
                            v-if="post.owner.investor"
                          >
                            <i
                              style=""
                              class="fas fa-chart-pie-simple-circle-dollar primary-color"
                            ></i>
                          </p>
                        </span>
                        <br />

                        <span
                          style="font-size: 12px; text-transform: none"
                          class="text-gray"
                          >@{{ post.owner.slug }}
                        </span>
                      </router-link>

                      <span class="text-gray"> • </span>

                      <span>
                        <i
                          class="fa-solid fa-earth-americas text-gray"
                          v-if="!post.subscribers_only"
                          style="cursor: pointer; font-size: 12px"
                        ></i>
                        <i
                          class="fa-solid fa-lock-alt"
                          v-else
                          style="
                            cursor: pointer;
                            font-size: 12px;
                            color: #007bff;
                          "
                        ></i>
                      </span>
                      <span class="text-gray"> • </span>
                      <span class="text-gray" style="font-size: 12px">{{
                        calcPostedAt(post.created_at)
                      }}</span>
                      <v-chip
                        x-small
                        v-if="post.paid && post.owner.id != me.id"
                        class="text-gray"
                        style="
                          margin-left: 8px;
                          font-size: 12px;
                          color: #007bff;
                          padding: 0.5rem;
                          background-color: rgba(0, 123, 255, 0.1);
                          border-radius: 1rem;
                        "
                      >
                        <i>paid {{ post.pay_per_view.toFixed(2) }}$</i>
                      </v-chip>
                      <v-chip
                        x-small
                        v-if="post.pay_per_view && post.owner.id == me.id"
                        class="text-gray"
                        style="
                          margin-left: 8px;
                          font-size: 12px;
                          color: #007bff;
                          padding: 0.5rem;
                          background-color: rgba(0, 123, 255, 0.1);
                          border-radius: 1rem;
                        "
                      >
                        <i>price {{ post.pay_per_view.toFixed(2) }}$</i>
                      </v-chip>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <i
                            v-bind="attrs"
                            v-on="on"
                            class="fa fa-ellipsis-h text-gray edit-post"
                            aria-hidden="true"
                            style="
                              position: absolute;
                              right: 0;
                              top: 50%;
                              right: 15px;
                              font-size: 20px;
                              transform: translateY(-50%);
                              cursor: pointer;
                            "
                          ></i>
                        </template>
                        <v-list>
                          <v-list-item
                            @click="deletePost(post.id)"
                            v-if="post.owner.id == me.id"
                          >
                            <v-list-item-title>
                              <i
                                class="fal fa-trash"
                                style="margin-right: 8px"
                              ></i>
                              Delete
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="post.owner.id != me.id"
                            @click="reportPost(post)"
                          >
                            <v-list-item-title>
                              <i
                                class="fal fa-flag"
                                style="margin-right: 8px"
                              ></i>
                              Report
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="copyPostShareLink(post)">
                            <v-list-item-title>
                              <i
                                class="fal fa-share-alt"
                                style="margin-right: 8px"
                              ></i>
                              Share
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </div>

          <!-- CAROUSEL POST -->
          <!-- TODO: O SPLIDE NO MOBILE TA COM BUG TA COMENO ESPACO DO OUTRO -->
          <splide
            class="feed-carousel"
            style="height: 550px; min-height: 300px; max-height: 550px"
            :options="options"
            @splide:moved="onMoveSplide"
            @splide:mounted="onSplideMounted"
            v-if="post.files.length > 1 && post.processed"
          >
            <splide-slide
              class="feed-carousel__slide video-wrapper"
              v-for="(file, fileIndex) in posts[postIndex].files"
              :key="fileIndex"
              :class="{
                'other-files-post-bg':
                  isAudio(file.file || '') ||
                  isPDF(file.file || '') ||
                  isDoc(file.file || '') ||
                  isExcel(file.file || ''),
              }"
              style="width: 768px"
            >
              <!-- BLUR BACKGROUND -->
              <img
                class="post-image-backdrop slider"
                v-if="
                  isVideo(file.video || '') ||
                  isImage(file.medium || file.blur || '')
                "
                :src="`${file.blur}`"
              />
              <!-- POST IMAGE -->

              <!-- TODO: MELHORAR O DESIGN DISSO QUANDO É PAYPERVIEW VIDEOS MULTIPLOS -->
              <!-- IF VIDEO IS PAYPER VIEW AND NOT UNLOCKED -->
              <div
                class="subscriber-only"
                v-if="
                  Number(post.pay_per_view > 0) &&
                  !post.paid &&
                  post.owner.id != me.id
                "
              >
                <img
                  :src="file.blur"
                  style="
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                  "
                />
                <img
                  :src="file.thumbnail"
                  style="
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin: auto;
                    height: 100%;
                    z-index: 2;
                  "
                />
                <div
                  style="
                    background-color: rgba(0, 0, 0, 0.5);
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    z-index: 3;
                  "
                ></div>
                <div
                  style="
                    z-index: 4;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <i class="fa-solid fa-lock"></i>
                  <v-btn
                    class="btn-sider-money"
                    style="color: #fff"
                    @click="openPayPerView(post)"
                  >
                    Pay {{ post.pay_per_view }}$ to see this post
                  </v-btn>
                  <small>To see this user post</small>
                </div>
              </div>

              <v-img
                @mouseover="handleMouseMoveVideo"
                class="post-image"
                :id="'medium-' + post.id"
                :style="
                  !post.iMSubscriber &&
                  post.subscribers_only &&
                  me.id != user.id
                    ? 'z-index: 0;'
                    : 'z-index: 1;'
                "
                v-if="isImage(file.medium || '')"
                :src="`${file.medium || ''}`"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      style="
                        position: absolute;
                        left: 0;
                        right: 0;
                        margin: auto;
                        top: 50%;
                        transform: translateY(-50%);
                      "
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <!-- SUBSCRIBER ONLY -->
              <div
                class="subscriber-only"
                v-if="
                  !post.iMSubscriber &&
                  post.subscribers_only &&
                  me.id != user.id
                "
              >
                <i class="fa-solid fa-lock"></i>
                <v-btn
                  class="btn-sider-money"
                  style="color: white !important"
                  @click="$store.state.openPopup = 'subscribe'"
                >
                  Subscribe
                </v-btn>
                <small>To see this user post</small>
              </div>
              <!-- VIDEO -->
              <s-video
                :subscriber-only="
                  Boolean(
                    !post.iMSubscriber &&
                      post.subscribers_only &&
                      me.id != user.id
                  ) ||
                  (Number(post.pay_per_view > 0) &&
                    !post.paid &&
                    post.owner.id != me.id)
                "
                :isCommenting="commentsBottomSheet"
                style="width: 100%; height: 100%; max-height: 550px"
                v-if="isVideo(file.video || '')"
                class="premium-video"
                :blur="`${file.blur}`"
                :thumbnail="`${file.thumbnail}`"
                :src="`${file.video}`"
              >
              </s-video>

              <div
                v-if="
                  isAudio(file.file || '') ||
                  isPDF(file.file || '') ||
                  isDoc(file.file || '') ||
                  isExcel(file.file || '')
                "
                class="other-files-post"
              >
                <span
                  v-if="isPDF(file.file || '')"
                  style="max-width: 300px; word-wrap: break-word"
                >
                  <i
                    class="fa fa-file-pdf-o"
                    style="font-size: 3em"
                    aria-hidden="true"
                  ></i>
                  <br /><br />
                  {{ file.file.split("/")[5] }}
                  <br /><br />
                  <a
                    :href="`${file.file}`"
                    download
                    style="text-decoration: none"
                  >
                    <v-btn elevation="0">
                      <span style="color: black">Download</span>
                    </v-btn>
                  </a>
                </span>
                <span
                  v-if="isDoc(file.file || '')"
                  style="max-width: 300px; word-wrap: break-word"
                >
                  <i
                    class="fa fa-file-word-o"
                    style="font-size: 3em"
                    aria-hidden="true"
                  ></i>
                  <br /><br />
                  {{ file.file.split("/")[5] }}
                  <br /><br />
                  <a
                    :href="`${file.file}`"
                    download
                    style="text-decoration: none"
                  >
                    <v-btn elevation="0">
                      <span style="color: black">Download</span>
                    </v-btn>
                  </a>
                </span>
                <span
                  v-if="isExcel(file.file || '')"
                  style="max-width: 300px; word-wrap: break-word"
                >
                  <i
                    class="fa fa-file-excel-o"
                    style="font-size: 3em"
                    aria-hidden="true"
                  ></i>
                  <br /><br />
                  {{ file.file.split("/")[5] }}
                  <br /><br />
                  <a
                    :href="`${file.file}`"
                    download
                    style="text-decoration: none"
                  >
                    <v-btn elevation="0">
                      <span style="color: black">Download</span>
                    </v-btn>
                  </a>
                </span>
                <span
                  v-if="isAudio(file.file || '')"
                  style="max-width: 300px; word-wrap: break-word"
                >
                  <!-- audio html -->
                  <audio controls style="height: 70px">
                    <source :src="`${file.file}`" type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                  <br /><br />
                  {{ file.file.split("/")[5] }}
                </span>
              </div>
            </splide-slide>
          </splide>

          <!-- SINGLE FILE POST -->
          <div
            v-else-if="post.files.length == 1 && post.processed"
            style="position: relative"
            class="video-wrapper"
            @mouseover="handleMouseMoveVideo"
          >
            <!-- BLUR BACKGROUND -->
            <img
              class="post-image-backdrop"
              v-if="isImage(post.files[0].medium || post.files[0].blur || '')"
              :src="`${post.files[0].blur}`"
            />
            <!-- POST IMAGE -->
            <v-img
              class="post-image"
              :id="'blur-paid-' + post.id"
              :style="
                (!post.iMSubscriber &&
                  post.subscribers_only &&
                  me.id != user.id) ||
                (Number(post.pay_per_view > 0) && !post.paid)
                  ? 'z-index: 0;'
                  : 'z-index: 1;'
              "
              v-if="
                isImage(post.files[0].blur || '') &&
                Number(post.pay_per_view > 0) &&
                !post.paid
              "
              :src="`${post.files[0].blur || ''}`"
            ></v-img>
            <PinchZoomImage
              class="post-image"
              :id="'medium-' + post.id"
              :style="
                (!post.iMSubscriber &&
                  post.subscribers_only &&
                  me.id != user.id) ||
                (Number(post.pay_per_view > 0) && !post.paid)
                  ? 'z-index: 0;'
                  : 'z-index: 1;'
              "
              v-if="
                isImage(post.files[0].medium || '') &&
                ((post.subscribers_only &&
                  !post.iMSubscriber &&
                  me.id == user.id) ||
                  Number(post.pay_per_view <= 0) ||
                  post.paid)
              "
              :src="`${post.files[0].medium || ''}`"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    style="
                      position: absolute;
                      left: 0;
                      right: 0;
                      margin: auto;
                      top: 50%;
                      transform: translateY(-50%);
                    "
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </PinchZoomImage>

            <v-img
              class="post-image"
              v-if="
                !post.iMSubscriber &&
                post.subscribers_only &&
                me.id != user.id &&
                Number(post.pay_per_view <= 0)
              "
              :src="post.files[0].blur"
            ></v-img>
            <!-- PLAY ICON VIDEO -->
            <!-- <i class="fa-solid fa-play-circle video-play-icon" v-if="isVideo(post.files[0].video || '')"></i> -->
            <!-- SUBSCRIBER ONLY -->
            <div
              class="subscriber-only"
              v-if="
                !post.iMSubscriber &&
                post.subscribers_only &&
                me.id != user.id &&
                !post.paid
              "
            >
              <i class="fa-solid fa-lock"></i>
              <v-btn
                class="btn-sider-money"
                style="color: white !important"
                @click="$store.state.openPopup = 'subscribe'"
              >
                Subscribe
              </v-btn>
              <small>To see this user post</small>
            </div>
            <!-- VIDEO -->

            <s-video
              :subscriber-only="
                Boolean(
                  (!post.iMSubscriber &&
                    post.subscribers_only &&
                    me.id != user.id) ||
                    (Number(post.pay_per_view > 0) &&
                      !post.paid &&
                      post.owner.id != me.id)
                )
              "
              :isCommenting="commentsBottomSheet"
              playsinline
              loop
              style="width: 100%; height: 100%; max-height: 550px"
              v-if="
                post.files.length == 1 && isVideo(post.files[0].video || '')
              "
              class="premium-video"
              :blur="`${post.files[0].blur}`"
              :thumbnail="`${post.files[0].thumbnail}`"
              :src="`${post.files[0].video}`"
            ></s-video>

            <div
              v-if="
                isAudio(post.files[0].file || '') ||
                isPDF(post.files[0].file || '') ||
                isDoc(post.files[0].file || '') ||
                isExcel(post.files[0].file || '')
              "
              class="other-files-post"
            >
              <template
                v-if="windowWidth > 768 && isPDF(post.files[0].file || '')"
              >
                <iframe
                  :src="post.files[0].file"
                  frameborder="0"
                  width="100%"
                  height="100%"
                  inline
                ></iframe>
              </template>
              <template v-else>
                <span
                  v-if="isPDF(post.files[0].file || '')"
                  style="max-width: 400px; word-wrap: break-word"
                >
                  <i
                    class="fa fa-file-pdf-o"
                    style="font-size: 3em"
                    aria-hidden="true"
                  ></i>
                  <br /><br />
                  {{ post.files[0].file.split("/")[5] }}
                  <br /><br />
                  <a
                    :href="`${post.files[0].file}`"
                    download
                    style="text-decoration: none"
                  >
                    <v-btn elevation="0">
                      <span style="color: black">Download</span>
                    </v-btn>
                  </a>
                </span>
                <span
                  v-if="isDoc(post.files[0].file || '')"
                  style="max-width: 400px; word-wrap: break-word"
                >
                  <i
                    class="fa fa-file-word-o"
                    style="font-size: 3em"
                    aria-hidden="true"
                  ></i>
                  <br /><br />
                  {{ file.file.split("/")[5] }}
                  <br /><br />
                  <a
                    :href="`${post.files[0].file}`"
                    download
                    style="text-decoration: none"
                  >
                    <v-btn elevation="0">
                      <span style="color: black">Download</span>
                    </v-btn>
                  </a>
                </span>
                <span
                  v-if="isExcel(post.files[0].file || '')"
                  style="max-width: 400px; word-wrap: break-word"
                >
                  <i
                    class="fa fa-file-excel-o"
                    style="font-size: 3em"
                    aria-hidden="true"
                  ></i>
                  <br /><br />
                  {{ post.files[0].file.split("/")[5] }}
                  <br /><br />
                  <a
                    :href="`${post.files[0].file}`"
                    download
                    style="text-decoration: none"
                  >
                    <v-btn elevation="0">
                      <span style="color: black">Download</span>
                    </v-btn>
                  </a>
                </span>
              </template>
              <span
                v-if="isAudio(post.files[0].file || '')"
                style="max-width: 400px; word-wrap: break-word"
              >
                <!-- audio html -->
                <audio controls style="height: 70px">
                  <source :src="`${post.files[0].file}`" type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
                <br /><br />
                {{ post.files[0].file.split("/")[5] }}
              </span>
            </div>
            <!-- IF VIDEO IS PAYPER VIEW AND NOT UNLOCKED -->
            <div
              class="subscriber-only"
              v-if="
                Number(post.pay_per_view > 0) &&
                !post.paid &&
                post.owner.id != me.id
              "
            >
              <i class="fa-solid fa-lock"></i>
              <v-btn
                class="btn-sider-money"
                style="color: #fff"
                @click="openPayPerView(post)"
              >
                Pay {{ post.pay_per_view }}$ to see this post
              </v-btn>
              <small>To see this user post</small>
            </div>

            <div
              v-if="
                Number(post.pay_per_view > 0) &&
                !post.paid &&
                post.owner.id != me.id
              "
              class="post-being-processed subscriber-only-no-image"
              style="display: none"
            ></div>
          </div>

          <div
            v-else-if="!post.processed"
            class="post-being-processed"
            style="position: relative"
          >
            <img
              v-if="post.files[0] && post.files[0].thumbnail"
              :src="post.files[0].thumbnail"
              style="
                width: 100%;
                height: 100%;
                object-fit: cover;
                position: absolute;
                background-color: rgba(0, 0, 0, 0.3);
                opacity: 0.5;
                z-index: 0;
              "
              @error="handleProcessingThumbnail"
            />
            <center style="z-index: 1">
              <h1>Your post is being processed.</h1>
              <br />
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </center>
          </div>

          <div class="post-being-processed" v-if="!postHasAnyFile(post)">
            <center>
              <span
                class="text-gray"
                :class="{ 'text-white': !postHasAnyFile(post) }"
                style="margin-left: 16px; font-size: 20px"
                :style="
                  !/\w/gm.test(post.description) ? 'font-size: 50px;' : ''
                "
                >{{ post.description }}</span
              >
            </center>
          </div>
          <div class="premium-footer">
            <div class="premium-icons">
              <span
                @click="likePost(post.id)"
                :class="{ liked: likedByMe(post.likes) }"
              >
                <i
                  class="fa-light fa-heart"
                  aria-hidden="true"
                  v-if="!likedByMe(post.likes)"
                ></i>
                <i class="fa-solid fa-heart" aria-hidden="true" v-else></i>
                <span>{{
                  post.likesCount
                    ? post.likesCount + post.likes.length
                    : post.likes.length
                }}</span></span
              >
              <span
                @click="(commentsBottomSheet = true), (commentingPost = post)"
                ><i class="fa-light fa-comment"></i>
                <span>{{
                  post.comments ? post.comments.length : 0
                }}</span></span
              >

              <span
                :style="{ color: sumDonations(post) > 0 ? '#007bff' : '' }"
                @click="
                  (commentsBottomSheet = true),
                    (commentingPost = post),
                    (automaticallyDonation = true)
                "
              >
                <i class="fas fa-dollar-sign"></i>
                <span>{{ sumDonations(post) }}</span>
              </span>
            </div>
          </div>
          <div style="margin-left: 16px">
            <span
              class="text-gray"
              v-if="postHasAnyFile(post)"
              :class="{ 'text-white': !postHasAnyFile(post) }"
              style=""
              >{{ post.description }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import utilsMixins from "@/mixins/utils";

import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import FeedComments from "./Feed/FeedComments.vue";

import PayPerViewPopup from "@/components/Popups/PayPerViewPopup.vue";

import PinchZoomImage from "@/components/shared/PinchZoomImage.vue";

export default {
  mixins: [utilsMixins],
  components: {
    Splide,
    SplideSlide,
    FeedComments,
    PayPerViewPopup,
    PinchZoomImage,
  },
  computed: {
    defaultImages() {
      return {
        avatar: process.env.VUE_APP_DEFAULT_USER_AVATAR,
        banner: process.env.VUE_APP_DEFAULT_USER_BANNER,
      };
    },
  },
  methods: {
    handleProcessingThumbnail(event) {
      event.target.style.display = "none";
      setTimeout(() => {
        const src = event.target?.src;
        // keep trying to load thumbnail
        event.target.src = src;
        event.target.style.display = "block";
      }, 10000);
    },
    handleThumbnailNotLoaded(event) {
      const subscriberOnlyNoImage = event.target.parentElement.querySelector(
        ".subscriber-only-no-image"
      );
      if (subscriberOnlyNoImage) {
        subscriberOnlyNoImage.style.display = "block";
      }
      event.target.style.display = "none";
    },
    reportPost(post) {
      this.$swal({
        title: "Report Comment",
        text: "Are you sure you want to report this comment?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, report it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.post("/api/v1/report", {
            post_id: post.id,
          });
          this.$swal({
            title: "Reported!",
            text: "Your report has been sent.",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
    copyPostShareLink(post) {
      // copy with native clipboard for mac
      if (navigator.clipboard) {
        navigator.clipboard.writeText(`${window.location.origin}/p/${post.id}`);
      } else {
        // fallback for safari
        const el = document.createElement("textarea");
        el.value = `${window.location.origin}/p/${post.id}`;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      this.$swal({
        title: "Copied!",
        text: "Link to share copied to clipboard",
        icon: "success",
        timer: 2000,
        showCancelButton: false,
        showConfirmButton: false,
      });
    },
    postHasAnyFile(post) {
      return post.files ? post.files.length > 0 : false;
    },
    async getBalance() {
      this.balance = await this.$http
        .get("/api/v1/getBalance")
        .then((res) => res.data.credits)
        .catch(() => 0);
    },
    async openPayPerView(post) {
      if (!this.me.id) return this.$router.push("/");
      await this.getBalance();
      this.showPayPerViewPopup = true;
      this.postPayPerView = post;
    },
    sumDonations(post) {
      return parseFloat(
        post.comments.length > 0
          ? post.comments
              .map((comment) =>
                comment.transaction ? parseFloat(comment.transaction.amount) : 0
              )
              .reduce((a, b) => a + b, 0)
          : 0
      ).toFixed(2);
    },
    onNewComment(comment) {
      this.$emit("newComment", comment);
    },
    onDeleteComment(comment) {
      this.$emit("deleteComment", comment);
    },
    handleMouseMoveVideo(el) {
      let videoThumb = el.target.parentElement.parentElement;
      // alert()
      if (videoThumb.querySelector("video")) {
        // videoThumb.querySelector('video').style.display = 'block'
        // videoThumb.querySelector('.post-image-backdrop').style.display = 'none'
        // videoThumb.querySelector('.v-image').style.display = 'none'
        // videoThumb.querySelector('.video-play-icon').style.display = 'none'
        // videoThumb.querySelector('video').play();
      }
    },
    onSplideMounted(splide) {
      this.splideObject = splide;
    },
    onMoveSplide() {
      // params: splide, newIndex, oldIndex;
      // TODO PAUSE VIDEO ON SLIDE
    },
    swipeTo(index) {
      this.splideObject.go(index);
    },
    openPostPopup() {
      this.$store.commit("setPopup", "create-post");
    },
    likedByMe(likes) {
      // console.log(likes)
      if (likes && typeof likes != "undefined") {
        return likes.filter((like) => like.user_id == this.me?.id).length > 0;
      }
      return false;
    },
    async deletePost(postId) {
      // use $swal
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http
            .delete(`/api/v1/deletePost`, {
              data: {
                postId,
              },
            })
            .then(() => {
              this.$emit("deletePost", postId);
            });
        }
      });
    },
    async likePost(postId) {
      if (!this.me.id) return this.$router.push("/login");

      let post = this.posts.filter((post) => post.id == postId)[0];

      if (this.likedByMe(post.likes)) {
        post.likes = post.likes.filter((like) => like.user_id != this.me?.id);
      } else {
        if (post.likes == null) post.likes = [];
        post.likes.push({
          user_id: this.me.id,
        });
      }

      // hot reload likes
      this.posts = this.posts.map((post) => {
        if (post.id == postId) {
          return post;
        }
        return post;
      });

      await this.$http.post(
        "/api/v1/likePost",
        {
          postId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    },
  },
  data: () => ({
    windowWidth: window.innerWidth,
    showPremiumCard: [],
    balance: 0,
    showPayPerViewPopup: false,
    postPayPerView: {},
    automaticallyDonation: false,
    commentingPost: {
      comments: [],
    },
    commentsBottomSheet: false,
    imageList: [],
    options: {
      rewind: true,
      width: 800,
      perPage: 1,
      lazyLoad: "nearby",
    },
    splideObject: {},
    indexSplie: 0,
  }),
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    posts: {
      type: Array,
      default: () => [],
      required: true,
    },
    showWelcomeCards: {
      type: Boolean,
      default: false,
    },
    showWelcomePostCard: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.liked {
  color: #ff0000 !important;
}

.subscriber-only {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;

  i {
    font-size: 100px;
    color: white;
  }

  .btn-sider-money {
    margin-top: 16px;
    box-shadow: none;
    font-weight: bolder;
  }

  small {
    color: var(--color-our-white);
    font-size: 16px;
    margin-top: 16px;
  }
}

.video-wrapper {
  min-height: 400px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.post-image-backdrop {
  z-index: 0;
  width: 100%;
  position: absolute;
  height: 100%;
  max-height: 550px;

  // &.slider{
  //   height: 100%;
  // }
}

.post-image {
  min-height: 300px;
  max-height: 550px;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
  z-index: 1;

  & .v-image__image {
    background-size: contain;
  }
}
</style>

<style lang="scss">
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}

.list-complete-enter,
  .list-complete-leave-to

  /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}

.feed-avatar img {
  object-fit: cover;
}
</style>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.welcome-card-wrapper {
}

.welcome-card {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__close {
    cursor: pointer;
    color: #000;
    position: absolute;
    right: 20px;
    top: 20px;

    & i {
      font-size: 20px;
    }
  }

  &__title h2 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  &__description {
    font-size: 14px;
    margin-bottom: 13px;
  }

  &__buttons {
    background: linear-gradient(
      90deg,
      rgba(21, 168, 216, 1) 0%,
      rgba(72, 79, 248, 1) 100%
    ) !important;

    & span {
      color: white !important;
    }
  }
}
</style>

<style lang="scss">
.video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  cursor: pointer;
  font-size: 100px;
  color: #fff;
  transition: opacity 0.5s;

  &:hover {
    opacity: 0.8;
    transition: opacity 0.5s;
  }
}
</style>

<!-- SLIDE STYLES -->
<style>
.splide__list {
  height: 100%;
}

.feed-carousel .splide__pagination__page,
.feed-carousel .splide__pagination__page.is-active {
  transform: translate3d(0, 41px, 0);
}

.splide__pagination__page.is-active {
  background-color: #007bff !important;
}

/* hide navigation */
.splide__arrows {
  display: none;
}
</style>

<style lang="scss">
.feed-carousel {
  width: 100%;
  height: 550px;
  min-height: 300px;
  max-height: 550px;

  &__slide {
    min-height: 300px;
    max-height: 550px;
    display: flex !important;
    place-items: center;
    height: 550px;
  }
}
</style>

<style>
.lg-video-cont {
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
